module.exports = __webpack_public_path__ + "static/sass holdings-logos-a1bb736442ab89d251f0abc1a487a6a4.jpeg";